import React from 'react';
import { Link } from 'react-router-dom';
import HorizontalScroller from './HorizontalScroller';
import noImage from '../../assets/no-image-640x400.jpg';
import { normalizeMediaUrl } from '../../api/base';

function normalizeCollection(c){
  if (!c) return null;
  const id = c.id ?? c.slug ?? Math.random();
  // API already returns localized 'title' based on locale parameter
  const title = c.title || c.name || 'Collection';
  const slug = c.slug || id;
  const coverRaw =
    c.cover ||
    c.cover_thumb ||
    c.image ||
    (Array.isArray(c.items) && c.items[0]?.cover_url) ||
    '';
  const coverNorm = coverRaw ? normalizeMediaUrl(coverRaw) : '';
  const cover = coverNorm || noImage;
  return { id, title, to: `/collections/${encodeURIComponent(slug)}`, cover };
}

export default function CollectionsSlider({
  items = [],
  perViewDesktop = 4,
  perViewTablet  = 3,
  perViewMobile  = 1,
  perViewTiny    = 1,
  itemMin = 220,
  itemMax = 330,
  pad = 8,
  gap = 12,
}) {
  const list = (Array.isArray(items) ? items : [])
    .map(normalizeCollection)
    .filter(Boolean);

  if (!list.length) return null;

  const isCompactDesktop = perViewDesktop <= 2;
  const maxWidthValue = isCompactDesktop
    ? perViewDesktop * itemMax + gap * (perViewDesktop - 1) + pad * 2
    : '100%';
  const shouldLimitDesktop = !isCompactDesktop;

  return (
    <HorizontalScroller
      perViewDesktop={perViewDesktop}
      perViewTablet={perViewTablet}
      perViewMobile={perViewMobile}
      perViewTiny={perViewTiny}
      itemMin={itemMin}
      itemMax={itemMax}
      maxWidth={maxWidthValue}
      centered
      pad={pad}
      gap={gap}
      limitDesktopWidth={shouldLimitDesktop}
    >
      {list.map((it) => (
        <div key={String(it.id)} style={{ width: 'var(--col-width)' }}>
          <Link
            to={it.to}
            style={{
              display:'block',
              background:'var(--card)',
              border:'1px solid var(--bdr)',
              borderRadius:16,
              overflow:'hidden',
              boxShadow:'var(--shadow)',
              color:'inherit',
              textDecoration:'none'
            }}
          >
            <img
              src={it.cover}
              alt={it.title}
              loading="lazy"
              decoding="async"
              style={{height:170, width:'100%', display:'block'}}
            />
            <h4
              style={{
                margin:'10px 12px 12px', fontSize:16, lineHeight:1.25,
                display:'-webkit-box', WebkitBoxOrient:'vertical', WebkitLineClamp:2,
                overflow:'hidden', minHeight:'2.5em',
                color: '#000',
                background: 'var(--gold)',
                opacity: 0.92,
                padding: '8px 12px',
                borderRadius: '12px',
                backdropFilter: 'blur(8px)',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.15)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                display: 'inline-block',
                width: 'calc(100% - 24px)',
                margin: '10px 12px 12px'
              }}
            >{it.title}</h4>
          </Link>
        </div>
      ))}
    </HorizontalScroller>
  );
}
